// Hook modyfikacji danych nagłówkowych oferty (status i/lub validUntil).
// PUT /sales-crm/clients/:cid/offers/:oid

import { axios } from 'api';
import { useMutation, UseMutationOptions } from 'react-query';
import { ICommandResponseError as IError, ICommandResponseSuccess } from 'api/types';

export interface IPutSalesCrmOfferPayload {
  /** Status oferty (1=W negocjacji, 2=Zaakceptowana, 3=Odrzucona, 4=Wygasła, 5=Anulowana) */
  status?: number;
  /** Data obowiązywania aktualnej wersji oferty (YYYY-MM-DD) */
  validUntil?: string;
  /** Flaga okresowości oferty (true = klient może wielokrotnie skorzystać w okresie ważności). */
  isPeriodic?: boolean;
  /** Id wersji do ustawienia jako aktualna (Offer.actualVersionId). Wersja musi należeć do tej oferty. */
  actualVersionId?: number;
}

type IResponse = ICommandResponseSuccess;

const putSalesCrmOffer = (
  clientId: number,
  offerId: string,
  payload: IPutSalesCrmOfferPayload
): Promise<IResponse> =>
  axios.put(`/sales-crm/clients/${clientId}/offers/${offerId}`, payload);

export const usePutSalesCrmOffer = (
  clientId: number,
  offerId: string,
  options?: UseMutationOptions<IResponse, IError, IPutSalesCrmOfferPayload>
) =>
  useMutation(
    (payload: IPutSalesCrmOfferPayload) => putSalesCrmOffer(clientId, offerId, payload),
    options
  );
